import { useCallback, useMemo } from 'react';

import map from 'lodash/map';

import { usePositionsGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function PositionFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  onChange: callback,
  filteredByOpeningTemplates = true,
  errorMessages = {},
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  onChange?: (value: number) => void;
  useContextFn: () => {
    positionId: number;
    setPositionId: (value: number) => void;
    setDraftId?: (value: number) => void;
  };
  filteredByOpeningTemplates?: boolean;
  errorMessages?: Record<string, string>;
}) {
  const { positionId: value, setPositionId: onChange } = useContextFn();
  const { data, isSuccess, isLoading } = usePositionsGet({
    filteredByOpeningTemplates: filteredByOpeningTemplates ?? false,
  });

  const { PositionLaborLevel } = useProLaborLevelDesignations();

  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: String(item.positionId),
        label: item.positionName ?? '',
        value: item.positionId,
      })),
    [data]
  );
  useAppendAllOption(options, withAllOption);

  const sharedOnChangeHandler = useCallback(
    (value: number) => {
      onChange(value);
      callback?.(value);
    },
    [callback, onChange]
  );

  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: sharedOnChangeHandler,
    isSuccess,
  });

  const handleChange = useTransformSelectValue<number>(sharedOnChangeHandler);
  const helperText = errorMessages['positionId'];
  return (
    <Select
      fullWidth
      size="small"
      value={value}
      label={PositionLaborLevel}
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
      hideStartAdornment={isLoading}
      isLoading={isLoading}
    />
  );
}
